
export class MediaQueryService {

	constructor() {}

	static getMediaQuery() : string {

		if (window.matchMedia('(max-width: 479px)').matches) {

			return 'x-small';

		} else if (window.matchMedia('(max-width: 767px)').matches) {

			return 'small';

		} else if (window.matchMedia('(max-width: 1023px)').matches) {

			return 'medium-small';

		} else if (window.matchMedia('(max-width: 1199px)').matches) {

			return 'medium';

		} else if (window.matchMedia('(max-width: 1280px)').matches) {

			return 'large';

		} else {

			return 'extra-large';

		}

	}

}



// WEBPACK FOOTER //
// ./services/media-query.service.ts